import React from 'react';
import {withTranslation} from 'react-i18next';
import {Form as FinalForm} from 'react-final-form';
import {Col, Form, Row, Table} from 'reactstrap';
import TextField from '../components/TextField';
import LoaderButton from '../components/LoaderButton';
import ModalManager from '../components/modal/ModalManager';
import {NotificationManager} from '../components/common/react-notifications';
import {mask, selectStyles} from '../helpers/Utils';
import {drop, findIndex, lowerCase} from 'lodash';
import Rbac from '../components/Rbac';
import Select from 'react-select';
import Api from '../services/Api';

class TransactionDetails extends React.Component {
  static defaultProps = {
    showInfo: true,
    showForm: true,
  };

  constructor(props) {
    super(props);
    this.statusOptions = [
      {label: props.t('Waiting'), value: 'WAITING'},
      {label: props.t('Accepted'), value: 'ACCEPTED'},
      {label: props.t('Pending'), value: 'PENDING'},
      {label: props.t('Registered'), value: 'SUBMITTED'},
      {label: props.t('Confirmed'), value: 'CONFIRMED'},
      {label: props.t('Rejected'), value: 'REJECTED'},
    ];
    this.state = {
      selectedStatus: this.statusOptions.find(item => item.value === props.transaction.status),
    };
  }

  sendDescription = async values => {
    try {
      const {t, transaction, updateList} = this.props;
      await Api.invoke('POST', '/admin-ui/update-withdraw-description', {
        ...values,
        transactionId: transaction.transactionId ? transaction.transactionId : transaction.id,
      });
      updateList(transaction.index, {description: values.description});
      NotificationManager.success(t('Description sent successfully'), t('Message'));
    } catch (e) {
      if (e.fieldError) {
        return e.fieldError;
      }
      throw e;
    }
  };

  sendTnxUrl = async values => {
    try {
      const {t, transaction, updateList} = this.props;
      await Api.invoke('POST', '/admin-ui/update-withdraw-trx-url', {
        ...values,
        transactionId: transaction.transactionId ? transaction.transactionId : transaction.id,
      });
      updateList(transaction.index, {transactionExplorerUrl: values.trxUrl});
      NotificationManager.success(t('Transaction confirmed and transaction url added successfully.'), t('Message'));
    } catch (e) {
      if (e.fieldError) {
        return e.fieldError;
      }
      throw e;
    }
  };

  onChangeStatus = status => {
    const {t} = this.props;
    ModalManager.open({
      isOpen: true,
      title: t('Confirm Update'),
      body: t('Are you sure you want to update transaction status ?'),
      buttons: [
        {
          color: 'primary',
          onClick: () => {
            this.updateStatus(status);
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('Accept'),
        },
        {
          color: 'grey',
          onClick: () => {
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('Close'),
        },
      ],
    });
  };

  getStatusOptions = () => {
    return drop(
      this.statusOptions,
      findIndex(this.statusOptions,item => item.value === this.state.selectedStatus.value) + 1
    );
  };

  updateStatus = async status => {
    this.setState({
      selectedStatus: status,
    });
    const {t, transaction, updateList, fireFetchData} = this.props;
    try {
      if (status.value !== 'ACCEPTED') {
        await Api.invoke('POST', '/admin-ui/update-withdraw-status', {
          status: status.value,
          transactionId: transaction.transactionId ? transaction.transactionId : transaction.id,
        });
        updateList(transaction.index, {status: status.value});
      } else {
        await Api.invoke('POST', '/admin-ui/accept-withdraw-request', {
          token: transaction.confirmationToken,
        });
        fireFetchData();
      }
      NotificationManager.success(t('Transaction status updated successfully'), t('Message'));
    } catch (e) {
      this.setState({
        selectedStatus: this.statusOptions.find(item => item.value === transaction.status),
      });
      console.log('error: ', e);
    }
  };

  render() {
    const {selectedStatus} = this.state;
    const {t, showInfo, showForm, transaction} = this.props;
    const {transaction_type, dest_address_info, cardNumber, refId, id, transactionExplorerUrl, currentConfirmationNumber, expectedConfirmationNumber, description, userDescription, ip, gateway, adminFirstName, adminLastName, adminUsername} = transaction;
    const type = lowerCase(transaction.type);
    return(
      <div className="table-row-sub py-2">
        {showInfo && <Table bordered responsive>
          <tbody>
          {transaction_type === 'BLOCKCHAIN' && !!expectedConfirmationNumber &&
            <tr>
              <td style={{width: 150}} className="text-info">{t('Confirmations')}</td>
              <td>{t('{{x}} from {{y}}', {
                x: currentConfirmationNumber,
                y: expectedConfirmationNumber,
              })}</td>
            </tr>
          }
          {type === 'deposit' && !!cardNumber &&
          <tr>
            <td style={{width: 150}} className="text-info">{t('Card Number')}</td>
            <td>{`${cardNumber.slice(12, 16)}*********${cardNumber.slice(0, 4)}`}</td>
          </tr>
          }
          {type === 'withdraw' &&
          selectedStatus.value !== 'WAITING' &&
          selectedStatus.value !== 'ACCEPTED' &&
          transaction_type === 'BLOCKCHAIN' &&
          !!dest_address_info &&
          !!dest_address_info.includes('mainAddress') &&
          !dest_address_info.includes('FROM_') &&
            <tr>
              <td style={{width: 150}} className="text-info">{t('Destination')}</td>
              <td>{JSON.parse(dest_address_info).mainAddress}</td>
            </tr>
          }
          {type === 'withdraw' &&
          selectedStatus.value !== 'WAITING' &&
          selectedStatus.value !== 'ACCEPTED' &&
          transaction_type !== 'BLOCKCHAIN' &&
          !!dest_address_info &&
          !dest_address_info.includes('FROM_') &&
          !!dest_address_info.includes('extraAddress') &&
          !!JSON.parse(dest_address_info).extraAddress &&
          <tr>
            <td style={{width: 150}} className="text-info">{t('Dest Card Number')}</td>
            <td>
              {mask(JSON.parse(dest_address_info).extraAddress, '####-####-####-####')}
            </td>
          </tr>
          }
          {type === 'withdraw' &&
          transaction_type !== 'BLOCKCHAIN' &&
          selectedStatus.value !== 'WAITING' &&
          selectedStatus.value !== 'ACCEPTED' &&
          !!dest_address_info &&
          !dest_address_info.includes('FROM_') &&
          !!dest_address_info.includes('mainAddress') &&
          <tr>
            <td style={{width: 150}} className="text-info">{t('Dest Sheba Number')}</td>
            <td>{`IR${JSON.parse(dest_address_info).mainAddress}`}</td>
          </tr>
          }
          {transaction_type !== 'BLOCKCHAIN' && type === 'deposit' && !!refId &&
            <tr>
              <td style={{width: 150}} className="text-info">{t('Ref')}</td>
              <td>{refId}</td>
            </tr>
          }
          {transaction_type !== 'BLOCKCHAIN' && type === 'withdraw' && !!id &&
            <tr>
              <td style={{width: 150}} className="text-info">{t('Ref')}</td>
              <td>{id}</td>
            </tr>
          }
          {transaction_type === 'BLOCKCHAIN' && !!transactionExplorerUrl &&
            <tr>
              <td style={{width: 150}} className="text-info">{t('Transaction Link')}</td>
              <td>
                {transactionExplorerUrl !== 'INTERNAL' ?
                  transactionExplorerUrl.includes('http') ?
                    <a
                      href={transactionExplorerUrl}
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      {transactionExplorerUrl.substring(0, 24)}
                      {'...'}
                      {transactionExplorerUrl.substring(
                        transactionExplorerUrl.length - 10,
                        transactionExplorerUrl.length,
                      )}
                    </a> : null
                    :
                  t('Exchange Internal Transaction')
                }
              </td>
            </tr>
          }
          {!!ip && <tr>
            <td style={{width: 150}} className="text-info">{t('User IP')}</td>
            <td>{ip}</td>
          </tr>}
          {!!gateway && <tr>
            <td style={{width: 150}} className="text-info">{t('Payment Gateway')}</td>
            <td>{gateway === 'admin' ? t('card to card') : t(gateway)}</td>
          </tr>}
          {!!adminUsername && <tr>
            <td style={{width: 150}} className="text-info">{t('Payer')}</td>
            <td>{`${adminFirstName ? `${adminFirstName} ${adminLastName} ` : ''}[${adminUsername}]`}</td>
          </tr>}
          {type === 'deposit' && !!description && <tr>
            <td style={{width: 150}} className="text-info">{t('Payer Description')}</td>
            <td>{description}</td>
          </tr>}
          </tbody>
        </Table>}
        {showForm && <Row>
          {(type === 'withdraw' &&
            selectedStatus.value !== 'REJECTED' &&
            selectedStatus.value !== 'CONFIRMED' &&
            selectedStatus.value !== 'BLOCKCHAIN_REJECTION'
          ) && <Col className='col-6'>
            <span>{t('Status')}</span>
            <Select
              className="w-100"
              styles={selectStyles}
              value={selectedStatus}
              onChange={this.onChangeStatus}
              options={this.getStatusOptions()}
              placeholder={t('Select')}
              isDisabled={!Rbac.hasPermission('update_user-withdraw-status')}
            />
          </Col>}
          {type === 'withdraw' && selectedStatus.value !== 'WAITING' && <Col>
            <FinalForm
              onSubmit={this.sendDescription}
              initialValues={{
                description,
                userDescription
              }}
              render={({handleSubmit, submitting, pristine}) => {
                return (
                  <Form onSubmit={handleSubmit} className="w-100">
                    <TextField
                      item={{
                        name: 'description',
                        i18n: t('Admin Description'),
                        type: 'textarea',
                        rows: 2,
                      }}
                    />
                    <TextField
                      item={{
                        name: 'userDescription',
                        i18n: t('Description to the user'),
                        type: 'textarea',
                        rows: 2,
                      }}
                    />
                    <LoaderButton
                      loading={submitting}
                      onClick={handleSubmit}
                      disabled={pristine || submitting}
                      className="my-1 text-center"
                      style={{minWidth: '100px'}}>
                      {t('Submit Description')}
                    </LoaderButton>
                  </Form>
                );
              }}
            />
          </Col>}
        </Row>}
        {showForm && transaction_type === 'BLOCKCHAIN' && <Row>
          {selectedStatus.value === 'PENDING' && <Col>
            <FinalForm
              onSubmit={this.sendTnxUrl}
              render={({handleSubmit, submitting, pristine}) => {
                return (
                  <Form onSubmit={handleSubmit} className="w-100">
                    <TextField
                      item={{
                        name: 'trxUrl',
                        i18n: t('Transaction URL'),
                        type: 'textarea',
                        rows: 2,
                      }}
                    />
                    <LoaderButton
                      loading={submitting}
                      onClick={handleSubmit}
                      disabled={pristine || submitting}
                      className="my-1 text-center"
                      style={{minWidth: '100px'}}>
                      {t('Add transaction link and confirm')}
                    </LoaderButton>
                  </Form>
                );
              }}
            />
          </Col>}
        </Row>}
      </div>
    );
  }
}

export default withTranslation()(TransactionDetails);
